import { HStack, Img, Text, VStack } from '@chakra-ui/react';
import { urlForImage } from '../../libs/sanity.image';
import type { Author } from '../../libs/sanity.queries';

export default function AuthorAvatar(props: Author) {
  const { name, image, jobTitle, ...styleProps } = props;
  return (
    <HStack spacing={4} {...styleProps}>
      <Img
        src={urlForImage(image).height(96).width(96).fit('crop').url()}
        objectFit='cover'
        width='48px'
        height='48px'
        rounded='full'
        alt={name}
      />
      <VStack spacing={1} alignItems='start'>
        <Text size='xl' fontWeight='bold'>
          {name}
        </Text>
        <Text size='lg' color='bg-default-inverted'>
          {jobTitle}
        </Text>
      </VStack>
    </HStack>
  );
}
